import React from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import Searched from '../components/Searched'
import Cuisine from './Cuisine'
import Home from './Home'
import Recipe from './Recipe'
import { AnimatePresence } from 'framer-motion'

export default function Pages() {
    const location = useLocation();
    return (
        <AnimatePresence exitBeforeEnter>
            <Routes location={location} key={location.pathname}>
                <Route path="" element={<Home />} />
                <Route path="/cuisine/:type" element={<Cuisine />} />
                <Route path="/searched/:search" element={<Searched />} />
                <Route path="/recipe/:id" element={<Recipe />} />
            </Routes>
        </AnimatePresence >
    )
}
